import React, { useContext, useState, useRef, useEffect } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert, Stack, Backdrop, CircularProgress } from '@mui/material';
import Header from './Header';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { endpoint } from '../../resource/Constant';
import { parseEmail } from '../../resource/Constant';
import AuthContext from '../SecurityConfig/AuthContext';

const LinkedInAuth = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(['', '', '', '']);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const otpInputs = useRef([]);
  const navigate = useNavigate();
  const { setLoginDetails, loginDetails } = useContext(AuthContext);
  const [sendingOtp, setSendingOtp] = useState(false);

  useEffect(() => {
    if (loginDetails.isAuthenticated) navigate('/linkedinpost/download');
  }, []);
  useEffect(() => {
    let timer;
    if (otpSent && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [otpSent, resendTimer]);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setMessage('');
    setSendingOtp(true);
    setError('');
    const params = { email: email };
    if (email === parseEmail) {
      axios.post(endpoint + '/api/linkedin/parse' , {} , {params : {...params}})
      .then((response) => {
        setMessage(response?.data?.message)
        localStorage.setItem('linkedin_token', response?.data?.jwt);
        localStorage.setItem('user_email', email);
        setLoginDetails({ isAuthenticated: true });
        setTimeout(() => navigate('/linkedinpost/download'), 1500);
      })
      .catch((error) => {
        setError(error?.response?.data?.detail)
      })
    }
    else {
    axios
    .post(endpoint + `/api/linkedin/sendotp`, {}, { params: { ...params } })
    .then((res) => {
      setMessage(res?.data?.message)
      setOtpSent(true);
      setResendTimer(30);
      setSendingOtp(false);
    })
    .catch((error) => {
      setError(error?.response?.data?.message || "Failed to send an OTP")
      setSendingOtp(false);
    })
    }
    
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    const otpValue = otp.join('');
      axios.post(endpoint + '/api/linkedin/verifyotp', null, {
        params: { email: email, otp: otpValue }
      })
      .then((res) => {
        setMessage(res?.data?.message)
        localStorage.setItem('linkedin_token', res?.data?.data?.token);
        localStorage.setItem('user_email', email);
        setLoginDetails({ isAuthenticated: true });
        setTimeout(() => navigate('/linkedinpost/download'), 1500);
      })
      .catch((error) => {
        setError(error?.response?.data?.message)
      })
  };

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      otpInputs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      otpInputs.current[index - 1].focus();
    }
  };

  const handleResendOtp = async () => {
    setSendingOtp(true);
    setMessage('');
    setError('');
      axios
      .post(endpoint + '/api/linkedin/sendotp', null, { params: { email: email } })
      .then((res) => {
        setMessage(res?.data?.message)
        setResendTimer(30);
        setOtp(['', '', '', '']);
        setSendingOtp(false);
      })
      .catch((error) => {
        setEmail(error?.response?.data?.message || "Failed to resend OTP. Please try again.")
        setSendingOtp(false);
      })
  };

  const handleChangeEmail = () => {
    setOtpSent(false);
    setEmail('');
    setOtp(['', '', '', '']);
    setMessage('');
    setError('');
  };

  return (
    <>
      <Header />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#f4f6f8',
          flexDirection: 'column',
          position: 'fixed',
          width: '100%'
        }}
      >
        <Paper sx={{ width: '100%', maxWidth: '470px', borderRadius: '12px', backgroundColor: 'white', boxShadow: 3, padding: 4 }}>
          <Typography variant="h6" sx={{ mb: 1, textAlign: 'center', fontWeight: 'bold', color: '#1976d2', fontSize: '[1.5rem]' }}>
            {otpSent ? 'Verify your Email' : 'LinkedIn Post Assistant'}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: '#64748b' }}>
            {!otpSent ? 'Enter your email to get started' : "We've sent a verification code"}
          </Typography>

          <form onSubmit={otpSent ? handleSignIn : handleSendOtp}>
            <TextField
              type="email"
              label="you@example.com"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2, borderRadius: '12px' }}
              required
              disabled={otpSent}
            />

            {otpSent && (
              <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 3 }}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    inputRef={(el) => (otpInputs.current[index] = el)}
                    type="text"
                    variant="outlined"
                    value={digit}
                    required
                    disabled={!otpSent}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    inputProps={{ maxLength: 1, style: { textAlign: 'center', fontSize: '18px', fontWeight: 'bold' } }}
                    sx={{ width: '50px', height: '50px' }}
                  />
                ))}
              </Stack>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ py: 1.5, fontSize: '16px', borderRadius: '8px', textTransform: 'none', mt: 1 }}
            >
              {otpSent ? 'Sign In' : 'Continue'}
            </Button>

            {otpSent && (
              <Typography
                variant="body2"
                sx={{
                  mt: 3,
                  color: resendTimer > 0 ? 'gray' : '#1976d2',
                  textAlign: 'center',
                  cursor: resendTimer > 0 ? 'default' : 'pointer'
                }}
                onClick={resendTimer === 0 ? handleResendOtp : null}
              >
                {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
              </Typography>
            )}

            {otpSent && (
              <Button fullWidth variant="text" sx={{ mt: 2, textTransform: 'none' }} onClick={handleChangeEmail}>
                Change Email
              </Button>
            )}
          </form>

          {message && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </Paper>
      </Box>

      <Backdrop open={sendingOtp} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default LinkedInAuth;
